module.exports = __webpack_public_path__ + "img/dingtalk_oauth2.b37545b8.png";